export default __webpack_public_path__ + "static/media/loader.67d87764.svg";